import React from 'react';
import { connect } from 'react-redux';
import Container from 'xgimi-ui/Container';
import Button from 'xgimi-ui/Button';
import images from '../../../assets/images';
import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';

import s from './.module.scss';

interface Props {
}

interface States {
}

/**
 * 反馈成功
 */
class Component extends StoreComponent<Props, States> {
  state: States = {
  };

  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback', titleKey: 'title' });
  }
  componentDidMount() {
  }
  /**
   * 跳转链接
   */
  private upgrade = () : void => {
    window.location.href = 'http://app.xgimi.com/download';
  };

  render(): React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <div className={s.top}>
          <img src={images.rocket} alt="rocket" className={s.image}/>
          <div className={s.success}>{this.t('lowVersion')}</div>
          <div className={s.thank}>{this.t('upgrade')}</div>
        </div>
        <Button className={s.button} color={'#007DFF'} onClick={() => this.upgrade()}>{this.t('goToUpgrade')}</Button>
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
